(function () {
  function initStudies(root) {
    var pills = root.querySelectorAll('[data-oleum-study-pill]');
    var panels = root.querySelectorAll('[data-oleum-study-panel]');
    if (!pills.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var id = pill.getAttribute('data-oleum-study-pill');
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var panel = root.querySelector('[data-oleum-study-panel="' + id + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function looksLikeStudyTitle(line) {
    if (!line) return false;
    if (/^(link|enlace|resumen):/i.test(line)) return false;
    if (/^https?:\/\//i.test(line)) return false;
    return line.length <= 100;
  }

  function parseStudies(raw) {
    if (!raw || !raw.trim()) return [];

    var lines = raw.split('\n');
    var studies = [];
    var current = null;

    function flushStudy() {
      if (!current || !current.title) return;
      current.body = current.bodyLines.join('\n').trim();
      delete current.bodyLines;
      studies.push(current);
      current = null;
    }

    function startStudy(title) {
      flushStudy();
      current = { title: title, link: '', bodyLines: [] };
    }

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;

      if (/^(link|enlace):/i.test(line)) {
        if (!current) current = { title: '', link: '', bodyLines: [] };
        current.link = line.replace(/^(link|enlace):\s*/i, '');
        continue;
      }

      if (/^resumen:/i.test(line)) {
        if (!current) current = { title: '', link: '', bodyLines: [] };
        current.bodyLines.push(line.replace(/^resumen:\s*/i, ''));
        continue;
      }

      if (/^https?:\/\//i.test(line)) {
        if (!current) current = { title: '', link: '', bodyLines: [] };
        current.link = line;
        continue;
      }

      if (current && current.bodyLines.length > 0) {
        if (looksLikeStudyTitle(line)) {
          startStudy(line);
        } else {
          current.bodyLines.push(line);
        }
        continue;
      }

      if (current && current.title && current.link) {
        current.bodyLines.push(line);
        continue;
      }

      if (current && current.title && !current.link) {
        if (looksLikeStudyTitle(line)) {
          startStudy(line);
        } else {
          current.bodyLines.push(line);
        }
        continue;
      }

      startStudy(line);
    }

    flushStudy();

    return studies
      .map(function (study, index) {
        return {
          id: 'study-' + index,
          title: study.title,
          link: study.link,
          body: study.body
        };
      })
      .filter(function (s) { return s.title; });
  }

  function buildStudies(root) {
    var rawEl = root.querySelector('[data-oleum-studies-raw]');
    if (!rawEl) return;
    var studies = parseStudies(rawEl.textContent);
    if (!studies.length) return;

    var pillsWrap = root.querySelector('[data-oleum-studies-pills]');
    var panelsWrap = root.querySelector('[data-oleum-studies-panels]');
    if (!pillsWrap || !panelsWrap) return;

    studies.forEach(function (study, i) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'oleum-pdp-studies__pill' + (i === 0 ? ' is-active' : '');
      pill.setAttribute('data-oleum-study-pill', study.id);
      pill.textContent = study.title;
      pillsWrap.appendChild(pill);

      var panel = document.createElement('div');
      panel.className = 'oleum-pdp-studies__panel' + (i === 0 ? ' is-active' : '');
      panel.setAttribute('data-oleum-study-panel', study.id);
      panel.innerHTML =
        '<div class="oleum-pdp-studies__panel-body"></div>' +
        '<div class="oleum-pdp-studies__panel-footer"></div>';
      panel.querySelector('.oleum-pdp-studies__panel-body').textContent = study.body;

      if (study.link) {
        var ctaLabel = root.getAttribute('data-studies-cta-label') || 'Explorar';
        var arrowSrc = root.getAttribute('data-studies-arrow') || '';
        var footer = panel.querySelector('.oleum-pdp-studies__panel-footer');
        var a = document.createElement('a');
        a.className = 'oleum-pdp-studies__panel-link';
        a.href = study.link;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';

        var label = document.createElement('span');
        label.className = 'oleum-pdp-studies__panel-link-label';
        label.textContent = ctaLabel;
        a.appendChild(label);

        if (arrowSrc) {
          var icon = document.createElement('span');
          icon.className = 'oleum-pdp-studies__panel-link-icon';
          icon.setAttribute('aria-hidden', 'true');
          var img = document.createElement('img');
          img.src = arrowSrc;
          img.alt = '';
          img.width = 16;
          img.height = 16;
          img.loading = 'lazy';
          icon.appendChild(img);
          a.appendChild(icon);
        } else {
          a.appendChild(document.createTextNode(' >'));
        }

        footer.appendChild(a);
      }
      panelsWrap.appendChild(panel);
    });

    initStudies(root);
  }

  function initRoutePanels(root) {
    var cards = root.querySelectorAll('[data-oleum-pdp-route-card]');
    var buttons = root.querySelectorAll('[data-oleum-pdp-route-open]');
    var panels = root.querySelectorAll('[data-oleum-pdp-route-panel]');
    if (!buttons.length || !panels.length) return;

    function activate(panelId, trigger) {
      var details = root.querySelector('[data-oleum-pdp-routes-details]');
      panels.forEach(function (panel) {
        var isActive = panel.id === panelId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
      cards.forEach(function (card) {
        card.classList.remove('is-active');
      });
      buttons.forEach(function (btn) {
        var expanded = btn.getAttribute('data-oleum-pdp-route-open') === panelId;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded && btn.closest('[data-oleum-pdp-route-card]')) {
          btn.closest('[data-oleum-pdp-route-card]').classList.add('is-active');
        }
      });
      if (details) {
        details.hidden = false;
        details.classList.add('is-open');
      }
      if (trigger && details) {
        details.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-oleum-pdp-route-open'), btn);
      });
    });
  }

  function initModals() {
    document.querySelectorAll('[data-oleum-pdp-modal-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-oleum-pdp-modal-open');
        var modal = document.getElementById(id);
        if (modal) modal.classList.add('is-open');
      });
    });

    document.querySelectorAll('[data-oleum-pdp-modal]').forEach(function (modal) {
      modal.querySelector('[data-oleum-pdp-modal-close]')?.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
      modal.querySelector('.oleum-pdp-modal__backdrop')?.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
    });
  }

  function initUgcCarousel(root) {
    var viewport = root.querySelector('[data-oleum-ugc-viewport]');
    var track = root.querySelector('[data-oleum-ugc-track]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('[data-oleum-ugc-slide]');
    if (slides.length === 0) return;

    function slideLeft(index) {
      var el = slides[index];
      return el ? el.offsetLeft - track.offsetLeft : 0;
    }

    function updateActive() {
      var scrollL = viewport.scrollLeft;
      var active = 0;
      var best = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slideLeft(i) - scrollL);
        if (d < best) {
          best = d;
          active = i;
        }
      }
      slides.forEach(function (slide, j) {
        slide.classList.toggle('is-active', j === active);
      });
    }

    var t;
    viewport.addEventListener(
      'scroll',
      function () {
        clearTimeout(t);
        t = setTimeout(updateActive, 60);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(t);
        t = setTimeout(updateActive, 120);
      },
      { passive: true }
    );

    if (slides.length > 1) {
      var centerIndex = Math.floor(slides.length / 2);
      viewport.scrollLeft = slideLeft(centerIndex);
    }

    updateActive();
  }

  // Loader de precio mientras se pide la sección actualizada al cambiar de variante.
  // 'variant:selected' dispara al elegir (antes del fetch); 'variant:update' dispara
  // cuando ya llegó el HTML nuevo (después). El timeout es respaldo por si el fetch
  // falla/aborta, ya que en ese caso 'variant:update' nunca llega.
  function initPriceLoading() {
    var LOADING_ATTR = 'data-price-loading';
    var timers = new WeakMap();

    function containerFor(target) {
      return target && target.closest ? target.closest('.product-oleum-pdp') : null;
    }

    document.addEventListener('variant:selected', function (e) {
      var container = containerFor(e.target);
      if (!container) return;
      container.setAttribute(LOADING_ATTR, '');
      clearTimeout(timers.get(container));
      timers.set(container, setTimeout(function () {
        container.removeAttribute(LOADING_ATTR);
      }, 8000));
    });

    document.addEventListener('variant:update', function (e) {
      var container = containerFor(e.target);
      if (!container) return;
      clearTimeout(timers.get(container));
      container.removeAttribute(LOADING_ATTR);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-oleum-studies-root]').forEach(buildStudies);
    document.querySelectorAll('[data-oleum-ugc-root]').forEach(initUgcCarousel);
    document.querySelectorAll('.oleum-pdp-routes').forEach(initRoutePanels);
    initModals();
    initPriceLoading();
  });
})();
